import type { IconProps } from './base';
import { BaseIcon } from './base';

export function IconFlagNOSmall(props: IconProps) {
  return (
    <BaseIcon {...props} size={props.size ?? 16} viewBox="0 0 16 16">
      <mask id="icon-flag-no-small" maskUnits="userSpaceOnUse" x="2" y="2" width="12" height="12">
        <rect x="2" y="2" width="12" height="12" rx="2" fill="#C4C4C4" />
      </mask>
      <g mask="url(#icon-flag-no-small)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 2C0 0.895431 0.895431 0 2 0H14C15.1046 0 16 0.895431 16 2V14C16 15.1046 15.1046 16 14 16H2C0.89543 16 0 15.1046 0 14V2Z"
          fill="#BA0C2F"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.22222 6.22222V0H9.77778V6.22222H16V9.77778H9.77778V16H6.22222V9.77778H0V6.22222H6.22222Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.22222 7.22222V0H8.77778V7.22222H16V8.77778H8.77778V16H7.22222V8.77778H0V7.22222H7.22222Z"
          fill="#00205B"
        />
        <rect x="2.5" y="2.5" width="11" height="11" stroke="#3C3C60" strokeOpacity="0.1" />
      </g>
    </BaseIcon>
  );
}
